// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M22.5 2V18H6.87574L1.5 22.7038V2H22.5ZM11 11H13.0039V8.99609H11V11ZM6 11H8.00391L8.00391 8.99609H6L6 11ZM16 11H18.0039V8.99609H16V11Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-chat-message-filled')
export default class ChatMessageFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'chat-message-filled',
    }
  }
}
